let FundamentalTabTemplateType = {
  Industrial : 1,
  Standard : 2,
}

export default FundamentalTabTemplateType;